import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import { OverrideReason } from '../../model/override-reason';
import { OverrideReasonPayload } from '../../model/override-reason-payload';

interface IPropsReasonSelect {
  reason: OverrideReason;
  selected: boolean;
  setSelected: Function;
  note: string;
  setNote: Function;
  alert: boolean;
}

function ReasonSelect({
  alert,
  reason,
  selected,
  setSelected,
  note,
  setNote,
}: IPropsReasonSelect) {
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={selected}
            value={selected}
            onChange={() => setSelected(reason.reasonId, !selected, reason.requiresNote)}
          />
        }
        label={<Typography variant='h4'>{reason.description}</Typography>}
      />
      {reason.requiresNote && (
        <>
          <TextField
            value={note}
            onChange={(e) => setNote(reason.reasonId, e.target.value)}
            size='small'
            placeholder='Add details here.'
            required={selected}
            error={alert}
            disabled={!selected}
            sx={{ m: { xs: '0 0 0 28px', md: '0 28px' } }}
            inputProps={{ style: { fontSize: '0.8rem' } }}
          />
          {selected && alert && (
            <Typography
              variant='h4'
              color='error'
              sx={{ m: { xs: '3px 0 0 28px' }, fontWeight: 'normal' }}
            >
              Please add details here for overriding
            </Typography>
          )}
        </>
      )}
    </>
  );
}

interface IPropsOverrideReasons {
  reasons: OverrideReason[];
  selections: OverrideReasonPayload[];
  setSelected: Function;
  setNote: Function;
  alert: boolean;
}

function OverrideReasons({
  alert,
  reasons,
  selections,
  setSelected,
  setNote,
}: IPropsOverrideReasons) {
  return (
    <FormGroup>
      {reasons.map((reason, index) => {
        const selectedReason = selections.find(
          (it) => it.reasonId === reason.reasonId
        );

        return (
          selectedReason && (
            <ReasonSelect
              key={reason.reasonId}
              reason={reason}
              alert={alert}
              selected={selectedReason.selected}
              setSelected={setSelected}
              note={selectedReason.note}
              setNote={setNote}
            />
          )
        );
      })}
    </FormGroup>
  );
}

export default OverrideReasons;
